import { Heart, Shirt, Users } from 'lucide-react';

const FEATURES = [
  {
    icon: Shirt,
    title: 'Quality Materials',
    description: 'Premium cotton blends and sustainable fabrics that feel amazing on both you and your pup.',
    color: '#c68b4d',
  },
  {
    icon: Heart,
    title: 'Perfect Match',
    description: 'Carefully designed sets that look coordinated without being too matchy-matchy.',
    color: '#e76f51',
  },
  {
    icon: Users,
    title: 'Community Love',
    description: 'Join 10,000+ pet parents who celebrate the bond with their furry best friends.',
    color: '#1e3a5f',
  },
];

export const WhyPoochCrew = () => {
  return (
    <section
      data-testid="why-poochcrew"
      className="py-24 bg-white"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-accent text-2xl text-[#c68b4d] block mb-2">Why Choose Us</span>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#1e3a5f]">
            Why PoochCrew?
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {FEATURES.map((feature, index) => (
            <div
              key={feature.title}
              data-testid={`feature-card-${index}`}
              className="group bg-[#f5f0e6]/50 backdrop-blur-sm p-8 rounded-3xl border border-[#c68b4d]/10 hover:bg-white hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${feature.color}15` }}
              >
                <feature.icon
                  className="w-8 h-8"
                  style={{ color: feature.color }}
                />
              </div>

              {/* Content */}
              <h3 className="font-heading text-xl font-semibold text-[#1e3a5f] mb-3">
                {feature.title}
              </h3>
              <p className="font-body text-base leading-relaxed text-[#1e3a5f]/70">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Banner */}
        <div className="mt-20 bg-[#1e3a5f] rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div data-testid="stat-happy-customers">
              <p className="font-heading text-4xl md:text-5xl font-bold text-white mb-2">10K+</p>
              <p className="font-body text-sm text-white/70">Happy Customers</p>
            </div>
            <div data-testid="stat-products">
              <p className="font-heading text-4xl md:text-5xl font-bold text-[#c68b4d] mb-2">50+</p>
              <p className="font-body text-sm text-white/70">Products</p>
            </div>
            <div data-testid="stat-rating">
              <p className="font-heading text-4xl md:text-5xl font-bold text-[#e76f51] mb-2">4.9</p>
              <p className="font-body text-sm text-white/70">Average Rating</p>
            </div>
            <div data-testid="stat-countries">
              <p className="font-heading text-4xl md:text-5xl font-bold text-white mb-2">15+</p>
              <p className="font-body text-sm text-white/70">Countries</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyPoochCrew;
